module.exports = __webpack_public_path__ + "img/search.991a4186.svg";